import React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

export const BrandPaper: React.FC<FlexProps> = ({
  children,
  className,
  ...props
}) => (
  <Flex
    bg="surface2"
    width="100%"
    p={2}
    flexDirection="column"
    justify="center"
    alignItems="center"
    transition="none"
    boxShadow="0px 8px 112px rgba(15, 12, 10, 0.12)"
    border="1px solid"
    borderColor="B.80"
    borderRadius={4}
    {...props}
  >
    {children}
  </Flex>
);
